<template>
  <div>
    <div class="top-section p-2 flex justify-end w-full items-center pr-12">
      <button
        v-if="sprintSaveErrors.length > 0"
        class="text-red mr-4 font-normal hover:bg-transparent hover:text-red  my-0"
        @click="showErrors"
      >
        ⚠ Failed to save few sprints, click here see
      </button>
      <div v-if="savingSprints" class="mr-4 flex justify-center items-center">
        <RadialProgress
          v-if="sprints.length > 0"
          :totalSteps="sprints.length"
          :completedSteps="updatedSprintsCount"
          :diameter="30"
          :strokeWidth="3"
          :animateSpeed="300"
          timingFunc="ease-out"
          :startColor="progressColor"
          :stopColor="progressColor"
        >
        </RadialProgress>
        <div
          v-if="updatedSprintsCount === sprints.length"
          class="text-green ml-3"
        >
          Updated all the sprints
        </div>
        <span v-else class="ml-3 inline-block"
          >Updated Spring {{ updatedSprintsCount }}/{{ sprints.length }}
        </span>
      </div>
      <button
        class="bg-green text-white px-4 h-full rounded-sm shadow-md  my-0"
        :disabled="savingSprints"
        @click="requestSave"
      >
        Save Sprints
      </button>
    </div>
    <div class="flex main">
      <div class="w-2/3 pt-0 sprints-container pr-2 relative">
        <button
          v-if="sprints.length > 0"
          class="expander all-sprints-expander text-xs bg-grey-light  my-0"
          title="Collapse all sprints"
          @click="expandAllSprints"
        >
          {{ expandedSprints.length > 0 ? "▼" : "►" }}S
        </button>
        <h2 class="text-center font-normal border-b pb-2 mb-2">
          Sprints for {{ cohort.name }}
        </h2>
        <div
          class="header-lables flex items-center justify-between font-bold sticky bg-white py-2 ml-12 pr-2"
          style="top: 0;"
        >
          <div class="w-1/4">
            Name
          </div>
          <div class="w-1/4 ml-4">
            Start Date
          </div>
          <div class="w-1/4 ml-4">
            End Date
          </div>
          <div class="w-1/5 flex items-center justify-around">
            <div class="days ml-4">
              Days
            </div>
            <div class="tasks">
              Tasks
            </div>
            <div>
              Opt
            </div>
          </div>
        </div>

        <div
          v-if="sprints.length === 0"
          class="mt-12 text-center absolute w-full text-base"
        >
          Tip: Click Add Sprint button to add sprint
        </div>

        <div class="w-full sprints-list overflow-auto p-3">
          <div
            v-for="(sprint, spIndex) in sprints"
            :key="`${sprint.id} + sprint`"
            class="edyst-form-group sprint fadeIn mb-2 relative"
            :style="
              !sprintExpanded(sprint.id) ? 'height: 2.5rem;' : 'height: auto;'
            "
          >
            <div
              class="flex justify-start items-center w-full sprint-header"
              :class="{ 'save-error': errorSprintIds.includes(sprint.id) }"
            >
              <button
                class="expander cursor-pointer my-0 bg-transparent"
                @click="expandSprint(sprint.id)"
              >
                {{ sprintExpanded(sprint.id) ? "▼" : "►" }}
              </button>
              <div class="flex items-center justify-between w-full">
                <div class="w-1/4 mr-2">
                  <input
                    v-model="sprint.name"
                    type="text"
                    class="mb-0"
                    placeholder="Sprint name"
                  />
                </div>
                <div class="w-1/4 mr-2">
                  <EdystDatePicker
                    v-model="sprint.start_date"
                    :selected="
                      sprint.start_date ? new Date(sprint.start_date) : null
                    "
                    placeholderText="Select start date"
                    class="sprint-date-picker"
                    name="start date"
                    @input="handleDateSelect($event, sprint.id)"
                  />
                </div>
                <div class="w-1/4 mr-2">
                  <EdystDatePicker
                    v-model="sprint.end_date"
                    :selected="
                      sprint.end_date ? new Date(sprint.end_date) : null
                    "
                    placeholderText="Select end date"
                    class="sprint-date-picker"
                    name="end date"
                    @input="handleDateSelect($event, sprint.id)"
                  />
                </div>
                <div class="w-1/6 flex items-center justify-between">
                  <div class="ml-2">
                    {{ sprint.plan.length }}
                  </div>
                  <div class="tasks">
                    {{ getTasksCountOfTheSprint(sprint.id) }}
                  </div>
                  <img
                    class="cursor-pointer hover:bg-grey-light mr-2"
                    style="width: 20px; height: 20px;"
                    src="/images/trash.png"
                    @click="removeSprint(sprint.id)"
                  />
                </div>
              </div>
            </div>

            <div
              v-if="sprintExpanded(sprint.id)"
              class="sprint-day p-2 mt-2 ml-8 mr-2"
            >
              <div
                v-if="sprint.plan.length === 0"
                class="text-xs text-grey-darker text-center"
              >
                Days are added automatically based on start and end date of the
                sprint
              </div>
              <div
                v-for="(day, dayIndex) in sprint.plan"
                :key="`${dayIndex}-day`"
                class="flex items-start mt-4 days"
              >
                <div class="py-1 px-2 w-1/5">
                  <div class="leading-tight">Day {{ day.day + 1 }}:</div>
                  <div class="leading-tight">
                    {{ getStartDateOfDay(sprint.start_date, day.day) }}
                  </div>
                  <div class="leading-tight">
                    ({{ day.tasks.length }} tasks)
                  </div>
                </div>
                <draggable
                  v-model="day.tasks"
                  ghost-class="ghost"
                  :group="{ name: 'question', pull: pullFunc, put: true }"
                  tag="ul"
                  :sort="true"
                  class="w-4/5 question-dropzone"
                  @add="handleAdd($event, sprint.id, day.day)"
                  @start="handleStart"
                >
                  <li
                    v-for="(question, qIdx) in day.tasks"
                    :key="question.item.id + qIdx"
                    class="list-item cursor-default question flex items-center justify-between truncate"
                    :class="{
                      'animate-drop': droppedItemIds.includes(question.item.id),
                    }"
                    :title="question.name"
                  >
                    <span class="flex items-center">
                      <i class="material-icons question-icon text-base">{{
                        iconToDisplay(question.item.type)
                      }}</i>
                      <i
                        class="material-icons question-flag question-icon text-lg mx-1 my-0"
                        :class="{ 'text-yellow': question.context.is_bonus }"
                        >{{
                          question.context.is_required
                            ? "playlist_add_check"
                            : question.context.is_bonus
                            ? "grade"
                            : ""
                        }}</i
                      >

                      <span class="ml-1">
                        {{ question.name }}
                      </span>
                    </span>
                    <button
                      title="Remove question"
                      class="remove ml-2 px-1 hover:bg-red cursor-pointer leading-none text-white bg-transparent my-0"
                      @click="removeQuestion(spIndex, dayIndex, qIdx)"
                    >
                      ✕
                    </button>
                  </li>
                </draggable>
              </div>
            </div>
          </div>
        </div>
        <div class="text-right bg-white my-2">
          <button
            class="add-sprint text-white px-4 py-2 rounded-sm shadow-md my-0"
            @click="addSprint"
          >
            + Add Sprint
          </button>
        </div>
      </div>
      <div class="w-1/3 pl-2 border-l">
        <h2
          class="text-center font-normal border-b pb-2 mb-2 sticky course-heading"
        >
          Course for {{ cohort.name }}
        </h2>
        <CourseTree
          v-if="coursePath.modules"
          :items="coursePath.modules"
          class="overflow-y-auto course-tree-container pr-4 fadeIn"
          :selectedQuestionIds="selectedQuestionIds"
          @TOPIC_DRAGGED="handleTopicDrag"
          @SELECTED_QUESTIONS_DRAGGED="handleQuestionsDrag"
        />
      </div>
      <span
        class="absolute text-xs flex items-center"
        style="bottom: 1rem; left: 1rem"
      >
        <i class="material-icons text-lg mx-1">playlist_add_check</i>
        Required |
        <i class="material-icons text-lg mx-1">grade</i> Bonus | Time is ignored
        when sprint days are generated from selected dates
      </span>
    </div>
    <VModal ref="errors_modal" name="errors_modal" width="600" height="50%">
      <div class="errors-modal leading-normal">
        <div v-for="(err, key) in sprintSaveErrors" :key="err + key">
          <div class="text-lg">{{ err.sprint.name }}</div>
          <ul>
            <li
              v-for="(item, key) in err.errors"
              :key="item + key"
              class="text-sm text-red"
            >
              {{ item }}
            </li>
          </ul>
        </div>
      </div>
    </VModal>
  </div>
</template>

<script>
import draggable from "vuedraggable"
import { differenceInCalendarDays, parseISO, addDays, format } from "date-fns"
import CourseTree from "@/components/Sprint/CourseTree"
import { generateRandomId } from "@/utils/mics"
import {
  getCalendar,
  getCourse,
  createSprint,
  updateSprint,
  deleteSprint,
} from "@/apis/calendar/index"
import RadialProgress from "@/components/Sprint/RadialProgress"
import EdystDatePicker from "@/components/ReactDatePicker/DatePicker"

export default {
  components: {
    CourseTree,
    draggable,
    RadialProgress,
    EdystDatePicker,
  },
  data() {
    return {
      ctrlKey: false,
      sprints: [],
      expandedSprints: [],
      cohort: {},
      coursePath: [],
      droppedItemIds: [],
      savingSprints: false,
      updatedSprintsCount: 0,
      currentSprintIndex: 0,
      sprintSaveErrors: [],
      draggedTopicQuestions: [],
      draggedSelectedQuestions: [],
    }
  },
  computed: {
    errorSprintIds() {
      return this.sprintSaveErrors.map(err => err.sprint.id)
    },
    selectedQuestionIds() {
      const ids = []
      this.sprints.forEach(sp => {
        sp.plan.forEach(day => {
          day.tasks.forEach(q => {
            ids.push(q.item.id)
          })
        })
      })
      return ids
    },
    icons() {
      return {
        0: "question_answer",
        1: "block",
        2: "assignment",
        3: "insert_drive_file",
        4: "video_library",
        5: "games",
        6: "code",
        7: "camera_alt",
        8: "casino",
        9: "web",
        12: "assignment",
      }
    },
    notyConfig() {
      return {
        timeout: 6000,
        layout: "bottomLeft",
      }
    },
    progressColor() {
      return this.sprints.length === this.updatedSprintsCount
        ? "#38c172"
        : "#6259c3"
    },
  },
  created() {
    this.getCalendarOfCohort()
  },
  methods: {
    handleTopicDrag(questions) {
      this.draggedTopicQuestions = questions
    },
    handleQuestionsDrag(questions) {
      this.draggedSelectedQuestions = questions
    },
    handleAdd(evt, sprintId, day) {
      if (evt.item.getAttribute("itemtype") === "topic") {
        // if a topic is dropped we request expansion of all the questions of it
        this.expandTopicQuestionsInSprint(sprintId, day)
      } else if (
        evt.item.getAttribute("itemtype") === "question" &&
        this.draggedSelectedQuestions.length > 0
      ) {
        // when questions are selected and dragged
        this.expandSelectedQuestions(evt.item.id, sprintId, day)
      } else {
        // default: when each question is dragged and dropped
        this.droppedItemIds.push(evt.item.id)
      }
      setTimeout(() => {
        this.droppedItemIds = []
      }, 500)
    },
    expandSelectedQuestions(questionId, sprintId, droppedOnDay) {
      const sprintIndex = this.sprints.findIndex(sp => sp.id === sprintId)
      this.sprints[sprintIndex].plan.forEach(day => {
        // only add the questions to the day on which the topic was dropped
        if (day.day === droppedOnDay) {
          const questionIndex = day.tasks.findIndex(
            q => q.item.id === questionId
          )
          this.droppedItemIds = this.draggedSelectedQuestions.map(
            q => q.item.id
          )
          /* splice does the magic here, triggers reactivity even on nested prop,
          it replaces the topic with all the questions of it at the same index */
          day.tasks.splice(questionIndex, 1, ...this.draggedSelectedQuestions)
        }
      })
      this.$nextTick(() => {
        this.draggedSelectedQuestions = []
      })
    },
    expandTopicQuestionsInSprint(sprintId, droppedOnDay) {
      /* when an entire topic is dropped we expand all the questions
       of it at the same index it was dropped */
      const sprintIndex = this.sprints.findIndex(sp => sp.id === sprintId)
      this.sprints[sprintIndex].plan.forEach(day => {
        // only add the questions to the day on which the topic was dropped
        if (day.day === droppedOnDay) {
          const topicIndex = day.tasks.findIndex(topic => topic.is_topic)
          this.droppedItemIds = this.draggedTopicQuestions.map(q => q.item.id)
          /* splice does the magic here, triggers reactivity even on nested prop,
          it replaces the topic with all the questions of it at the same index */
          day.tasks.splice(topicIndex, 1, ...this.draggedTopicQuestions)
        }
      })
      this.$nextTick(() => {
        this.draggedTopicQuestions = []
      })
    },
    async removeSprint(id) {
      const sprint = this.sprints.find(sp => sp.id === id)
      const v = await this.$swal({
        title: `Delete Sprint ${sprint.name}`,
        text: `Are you sure you want to delete the sprint?`,
        icon: "warning",
        buttons: {
          cancel: true,
          confirm: {
            text: "Yes, Delete",
            value: "delete",
          },
        },
      })
      if (v === "delete") {
        if (sprint.id && sprint.id.length > 6) {
          deleteSprint(sprint.id)
            .then(() => {
              this.$noty.info("Sprint Deleted from remote", this.notyConfig)
            })
            .catch(err => {
              console.error(err)
              this.$noty.error(
                "Failed to delete the sprint from remote",
                this.notyConfig
              )
            })
        }
        this.sprints = this.sprints.filter(sp => sp.id !== id)
      }
    },
    removeQuestion(spIndex, dayIndex, qIdx) {
      // splice triggers reactivity on nested prop
      this.sprints[spIndex].plan[dayIndex].tasks.splice(qIdx, 1)
    },
    expandSprint(id) {
      if (!this.sprintExpanded(id)) {
        this.expandedSprints.push(id)
      } else {
        this.expandedSprints = this.expandedSprints.filter(spId => spId !== id)
      }
    },
    sprintExpanded(id) {
      return this.expandedSprints.includes(id)
    },
    expandAllSprints() {
      if (this.expandedSprints.length > 0) {
        this.expandedSprints = []
      } else {
        this.expandedSprints = this.sprints.map(sp => sp.id)
      }
    },
    getTasksCountOfTheSprint(id) {
      const sprint = this.sprints.find(sp => sp.id === id)
      let count = 0
      sprint.plan.forEach(day => {
        count += day.tasks.length
      })
      return count
    },
    getSprintDays(startDate, endDate) {
      if (startDate && endDate) {
        const minDay = 1
        return (
          minDay +
          differenceInCalendarDays(
            parseISO(new Date(endDate).toISOString()),
            parseISO(new Date(startDate).toISOString())
          )
        )
      }
      return 0
    },
    getStartDateOfDay(start_date, days) {
      if (start_date) {
        return format(
          addDays(parseISO(new Date(start_date).toISOString()), days),
          "dd-MM-yyyy"
        )
      }
      return "------"
    },
    addSprint() {
      const sprint = {
        // do not send this id to backend, only for FE use
        id: generateRandomId(),
        cohort_id: this.cohort.id,
        start_date: "",
        end_date: "",
        name: "Test Sprint",
        plan: [],
      }
      this.sprints.push(sprint)
      this.expandedSprints.push(sprint.id)
    },
    handleDateSelect($event, spId) {
      /* if sprint is lenthened we add new days
        if shortened we remove days and add questions
        of those days to last day of the sprint */
      const sprint = this.sprints.find(sp => sp.id === spId)
      if (!sprint.start_date || !sprint.end_date) {
        // remove days when any of the dates are cleared
        sprint.plan = []
        return
      }
      const newCalculatedDays = this.getSprintDays(
        sprint.start_date,
        sprint.end_date
      )
      let updatedDays = []
      if (newCalculatedDays > sprint.plan.length) {
        const daysToAddCount = newCalculatedDays - sprint.plan.length
        const newDays = []
        // add new plan
        for (let i = 0; i < daysToAddCount; i++) {
          newDays.push({
            day: 0,
            tasks: [],
          })
        }
        updatedDays = [...sprint.plan, ...newDays]
        let firstDay = 0
        updatedDays.forEach(day => {
          day.day = firstDay
          firstDay += 1
        })
        if (sprint.plan.length > 0) {
          const text = `You lengthened the sprint by modifying the date. ${daysToAddCount} day(s) added with empty questions. Please adjust accordingly`
          this.$noty.info(text, this.notyConfig)
        }
        sprint.plan = updatedDays
      } else if (
        sprint.plan.length > 0 &&
        newCalculatedDays < sprint.plan.length
      ) {
        const daysToRemoveCount = sprint.plan.length - newCalculatedDays
        const removedDays = sprint.plan.splice(
          sprint.plan.length - daysToRemoveCount,
          daysToRemoveCount
        )
        const allRemovedTasks = []
        if (sprint.plan.length !== 0) {
          // add questions of removed plan
          removedDays.forEach(d => {
            allRemovedTasks.push(...d.tasks)
          })
          sprint.plan[sprint.plan.length - 1].tasks = [
            ...sprint.plan[sprint.plan.length - 1].tasks,
            ...allRemovedTasks,
          ]
        }
        const text = `You shortened the sprint by modifying the date. ${daysToRemoveCount} day(s) removed and ${
          allRemovedTasks.length > 0 ? allRemovedTasks.length : 0
        } questions of removed days are added to last day of the sprint. Please adjust accordingly`
        this.$noty.info(text, this.notyConfig)
      }
    },
    pullFunc() {
      return this.ctrlKey ? "clone" : true
    },
    handleStart({ originalEvent }) {
      this.ctrlKey = originalEvent.ctrlKey
    },
    iconToDisplay(type) {
      return this.icons[type] ? this.icons[type] : "report_problem"
    },
    getCalendarOfCohort() {
      getCalendar(this.$route.params.cohortId)
        .then(res => {
          res.data.sprints.forEach(sprint => {
            sprint.plan.sort((a, b) => a.day - b.day)
          })
          this.sprints = res.data.sprints
          this.cohort = res.data.cohort
          getCourse(this.cohort.course_id)
            .then(response => {
              this.prepareCourseResponse(response.data.path)
            })
            .catch(err => {
              console.error(err)
              this.$noty.error("Failed to fetch course", this.notyConfig)
            })
        })
        .catch(err => {
          console.error(err)
          this.$noty.error("Failed to fetch sprints details", this.notyConfig)
        })
    },
    requestSave() {
      this.updatedSprintsCount = 0
      this.currentSprintIndex = 0
      this.sprintSaveErrors = []
      for (let i = 0; i < this.sprints.length; i++) {
        if (!this.sprints[i].name) {
          this.$noty.error(
            "Name not present for all the sprints",
            this.notyConfig
          )
          return
        }
        if (!this.sprints[i].start_date) {
          this.$noty.error(
            "Start date not present for all the sprints",
            this.notyConfig
          )
          return
        }
        if (!this.sprints[i].end_date) {
          this.$noty.error(
            "End date not present for all the sprints",
            this.notyConfig
          )
          return
        }
      }
      this.saveSprint()
    },
    async saveSprint() {
      if (this.sprints.length === 0) {
        return
      }
      this.savingSprints = true
      const currentSprint = this.sprints[this.currentSprintIndex]
      const payload = { ...currentSprint, cohort_id: this.cohort.id }
      payload.start_date = new Date(currentSprint.start_date).toISOString()
      payload.end_date = new Date(currentSprint.end_date).toISOString()

      let res
      // temp id generated by FE
      const { id } = currentSprint
      try {
        if (currentSprint.id.length > 6) {
          res = await updateSprint(currentSprint.id, payload)
        } else {
          // remove temp id used by FE
          Reflect.deleteProperty(payload, "id")
          res = await createSprint(payload)
        }
        this.updateLocalSprintWithRemoteData(id, res.data.sprint)
        this.moveToNextSprint()
      } catch (err) {
        this.savingSprints = false
        if (err.response && err.response.data) {
          if (err.response.data.errors) {
            const { errors } = err.response.data
            this.sprintSaveErrors.push({
              sprint: currentSprint,
              errors,
            })
            if (!this.expandedSprints.includes(currentSprint.id)) {
              this.expandedSprints.push(currentSprint.id)
            }
          } else {
            this.$noty.error(err.response.data.message, this.notyConfig)
          }
        }
        this.moveToNextSprint()
      }
    },
    updateLocalSprintWithRemoteData(id, sprint) {
      /* post save we update local sprint with remote document as
      we need the id next time we want to update the sprint */
      const sprintIndex = this.sprints.findIndex(item => item.id === id)
      this.sprints.splice(sprintIndex, 1, sprint)
    },
    moveToNextSprint() {
      if (this.currentSprintIndex + 1 === this.sprints.length) {
        if (this.sprintSaveErrors.length > 0) {
          this.savingSprints = false
        }
        this.updatedSprintsCount += 1
        setTimeout(() => {
          this.savingSprints = false
          this.updatedSprintsCount = 0
          this.currentSprintIndex = 0
        }, 3000)
      } else {
        this.updatedSprintsCount += 1
        this.currentSprintIndex += 1
        this.saveSprint()
      }
    },
    showErrors() {
      this.$modal.show("errors_modal")
    },
    prepareCourseResponse(path) {
      path.modules.forEach((module, moduleIndex) => {
        module.topics.forEach(topic => {
          // only for topic drag and drop feature
          topic.is_topic = true
          topic.item = { id: topic.id }
          topic.context = { is_required: true, is_bonus: false }

          topic.questions = topic.questions.map(question =>
            // prepare task object from question object
            ({
              name: question.name,
              type: 1,
              item: { id: question.id, type: question.type },
              context: {
                slug: question.slug,
                is_bonus: question.is_bonus,
                is_required: question.is_required,
                cohort_slug: this.cohort.slug,
                module_slug: module.slug,
                topic_slug: topic.slug,
                module_index: moduleIndex,
              },
            })
          )
        })
        /* assignments are also treated similar to questions by backend
          adding assignment at the end */
        if ("assignment" in module) {
          // NOTE: item.type below is only for frontend use, assignments don't have types
          module.topics.push({
            name: "👨‍💻 Assignments",
            is_topic: true,
            id: module.assignment.id,
            item: { id: module.assignment.id },
            context: { is_required: true, is_bonus: false },
            questions: [
              {
                name: module.assignment.name,
                type: 2,
                item: { id: module.assignment.id, type: 2 },
                context: {
                  is_required: true,
                  is_bonus: false,
                  cohort_slug: this.cohort.slug,
                  module_slug: module.slug,
                  module_index: moduleIndex,
                },
              },
            ],
          })
        }
      })
      this.coursePath = path
    },
  },
}
</script>

<style scoped>
.edyst-form-group input[type="text"] {
  margin-top: 0;
  font-size: 0.9rem;
}

.top-section {
  height: 3rem;
}

.main {
  height: calc(100vh - 5rem);
  font-size: 0.9rem;
}

.course-tree-container {
  height: calc(100% - 3rem);
  transform: translateZ(0);
  will-change: transform;
}

.sprints-list {
  height: calc(100% - 7.5rem);
  padding-bottom: 2rem;
  transform: translateZ(0);
  will-change: transform;
}

.question {
  margin: 0 0 0.5rem 0;
  padding: 0.4rem 0.5rem;
  border-radius: 3px;
  color: #fff;
  background: #38c172;
  list-style-type: none;
  cursor: move;
}

.question:hover {
  background: #2c9056;
}

.question:last-child {
  margin-bottom: 0;
}

.question-name-move {
  transition: 1s;
}

.ghost {
  opacity: 0.5;
  color: #fff;
  background: #6259c3;
}

.animate-drop {
  animation: dropped 0.5s ease-in;
}

.add-sprint {
  background-color: #6259c3;
}

.question-dropzone {
  min-height: 4rem;
  padding: 0.2rem;
  border: 2px dashed #dfdfdf;
}

.remove {
  padding: 1px 3px;
  border-radius: 2px;
  line-height: 1.1;
}

.header-lables,
.course-heading {
  z-index: 1;
  top: 0;
  background: white;
}

.sprint:nth-child(2) {
  border-top: none;
}

.sprint-header {
  position: relative;
  padding: 0.2rem;
  background: white;
  box-shadow: 0 2px 5px 0 #747474;
}

.days:first-child {
  margin-top: 0;
}

.sprint-day::before {
  position: absolute;
  z-index: -100;
  top: 1.1rem;
  left: 1.1rem;
  height: 100%;
  border: 1px solid #dddddd;
  content: " ";
}

.expander {
  width: 1.8rem;
  padding: 0.5rem;
  border-radius: 3px;
}

.all-sprints-expander {
  position: absolute;
  top: 5.3rem;
  left: -3rem;
  width: 2.5rem;
}

.expander:focus,
.expander:hover,
.expander:active {
  outline: none;
  color: inherit;
  background-color: #e0e0e0;
}

.sprints-list::-webkit-scrollbar,
.course-tree-container::-webkit-scrollbar {
  width: 8px;
}

.sprints-list::-webkit-scrollbar-thumb,
.course-tree-container::-webkit-scrollbar-thumb {
  border-radius: 100px;
  outline: 0px solid #cacaca;
  background-color: #cacaca;
}

.sprints-list::-webkit-scrollbar-thumb:hover,
.course-tree-container::-webkit-scrollbar-thumb:hover {
  animation: scrollbig 0.3s;
}

.errors-modal {
  padding: 2rem;
}

.save-error {
  border: 1px solid #ff6666;
  background: #ffe2e2;
}

@keyframes scrollbig {
  0% {
    outline: 1px solid #c5c5c5;
    background-color: #c5c5c5;
  }
  1% {
    background: green;
  }
  100% {
    background: blue;
  }
}

@keyframes dropped {
  0% {
    opacity: 0.5;
    background: #38c172;
  }
  100% {
    opacity: 1;
    background: #38c172;
    box-shadow: none;
  }
}
</style>

<style>
.sprint-date-picker input[type="text"] {
  min-width: 150px;
  margin-bottom: 0;
  font-size: 0.9rem !important;
}

.question-flag {
  display: inline-block;
  width: 1rem;
  height: auto;
  text-align: center;
}

.edyst-form-group .react-datepicker__input-container > input[type="text"] {
  margin-top: 0;
}
</style>
